import { CHART_IDS } from '../charts/chartIds'

const SOURCE_DRIVEN_CHART_IDS = new Set([
  CHART_IDS.ALLUVIAL_DIAGRAM,
  CHART_IDS.ARC_DIAGRAM,
  CHART_IDS.SANKEY_DIAGRAM,
])

export function annotateColorDomainAttributes(svgNode, chart, colorDimension) {
  if (!svgNode) return

  const chartId = chart?.metadata?.id || ''
  const isSourceDrivenChart = SOURCE_DRIVEN_CHART_IDS.has(chartId)

  Array.from(
    svgNode.querySelectorAll('path, rect, circle, polygon, ellipse, line')
  ).forEach((node) => {
    const datum = node.__data__
    if (!datum || typeof datum !== 'object') return

    let domainValue = null

    if (isSourceDrivenChart) {
      if (datum.id !== undefined && datum.id !== null) {
        domainValue = datum.id
      } else if (datum.source?.id !== undefined && datum.source?.id !== null) {
        domainValue = datum.source.id
      }
    } else if (
      colorDimension &&
      datum[colorDimension] !== undefined &&
      datum[colorDimension] !== null
    ) {
      domainValue = datum[colorDimension]
    } else if (datum.color !== undefined && datum.color !== null) {
      domainValue = datum.color
    }

    if (domainValue !== null) {
      node.setAttribute('data-rawgraphs-color-domain', String(domainValue))
    }
  })
}
